module.exports = __webpack_public_path__ + "img/slide3-desktop.f0aa798a.png";